module.exports = __webpack_public_path__ + "img/framework4_Image.17377a0d.png";